import api from '@/services/api'

export default {
  /**
   * @return {Object} current user
   */
  async getLicense() {
    try {
      const res = await api.get('/license')
      return res.data
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return null
      }

      throw `License api service ${error}`
    }
  },
}
